import { ComponentStyleConfig } from '@chakra-ui/react';

export const radio: ComponentStyleConfig = {
  defaultProps: {
    colorScheme: 'brand',
  },
};
